import Layout from '@/views/layout/Layout'

const cmsAlbumRoute = {
  path: '/cms/luqu',
  component: Layout,
  redirect: '/cms/luqu/list',
  name: 'cms.luqu',
  meta: { title: '录取', icon: 'tree' },
  children: [
    {
      path: 'list',
      name: 'cms.luqu.list',
      component: () => import('@/views/cms/luqu/list'),
      meta: { title: '录取查询', icon: 'ums-admin' }
    }
  ]
}

export default cmsAlbumRoute



// WEBPACK FOOTER //
// ./src/router/module/cmsLuqu.js